export default "__VITE_ASSET__CykCBKJE__"